import React from "react";
import { ReactComponent as UserIco } from "../../../../Assets/user-square.svg";
import { Link } from "react-router-dom";
import * as ST from "./styled";
import { observer } from "mobx-react-lite";
import AuthStore from "../../../../Store/AuthStore";

type EntranceProps = {
	openerFunction: () => void;
	open: boolean;
};

const EntranceMobile = observer<EntranceProps>(({ openerFunction, open }) => {
	const nameCurrent = AuthStore.name;
	const surname = AuthStore.surname;
	const email = AuthStore.email;

	const name =
		nameCurrent && surname
			? nameCurrent === "null" || surname === "null"
				? email || undefined
				: `${nameCurrent} ${surname}`
			: undefined;

	return (
		<>
			{!name && !email ? (
				<Link to="/lk/auth">
					<ST.EntranceMobile>
						<UserIco />
					</ST.EntranceMobile>
				</Link>
			) : (
				<ST.EntranceMobile onClick={() => openerFunction()}>
					<UserIco />
				</ST.EntranceMobile>
			)}
		</>
	);
});

export default EntranceMobile;
